// enquiry.js （已加入顯示停車場名稱 + 根據語言自動切換）
import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, TextField, Button, Typography, CircularProgress, IconButton, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { searchCarplate } from '../api';
import VirtualKeyboard from '../components/VirtualKeyboard';
import '../styles/Enquiry.css';
import { AppContext } from '../contexts/AppContext';

function Enquiry() {
  const { carParkInfo, currentLang, setCurrentLang } = useContext(AppContext);
  const [carplate, setCarplate] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [entryTimestamp, setEntryTimestamp] = useState(null);
  const notDateTime = localStorage.setItem('entryTimestamp', Date.now());
  useEffect(() => {
    setEntryTimestamp(Date.now());
console.debug(`[ENQUIRY LOG] ENTRY TIMESTAMP SET: ${notDateTime}`);
  }, []);
  // === 新增：根據語言取得停車場名稱 ===
  const getCarParkName = () => {
    if (!carParkInfo) return '';
    
    switch (currentLang) {
      case 'zh-cn':
        return carParkInfo.carParkNameCn || carParkInfo.carParkNameEn || carParkInfo.carParkCode;
      case 'zh-tw':
        return carParkInfo.carParkNameTw || carParkInfo.carParkNameEn || carParkInfo.carParkCode;
      case 'en':
      default:
        return carParkInfo.carParkNameEn || carParkInfo.carParkCode;
    }
  };

  // TRANSLATIONS （原有 + 可選加 carPark 相關）
  const translations = {
    'zh-tw': {
      title: '繳付泊車費',
      carParkLabel: '', // 新增：用嚟顯示「停車場：XXX」
      label: '請 輸 入 您 的 車 牌 號 碼',
      placeholder: '車 牌 號 碼 ',
      back: '返回',
      next: '下一步',
      loadingTitle: '載入中...',
      noCarplate: '請輸入車牌號碼，例如：AB1234、粵B1Q15N',
      invalidGuid: 'GUID 無效，請重新登入',
      notFound: '沒 有 進 場 記 錄，請 重 新 輸 入',
      charging: '付 款 前 請 先 駛 離 充 電 車 位',
      systemError: '查詢失敗，系統錯誤，請重新嘗試',
      invalidFormat: '車牌格式不正確，請重新檢查',
      entryTimestampExpired: '資料已過期，請重新搜尋車牌'
    },
    'zh-cn': {
      title: '支付停车费',
      carParkLabel: '',
      label: '请 输 入 您 的 车 牌 号 码',
      placeholder: '车 牌 号 码 ',
      back: '返回',
      next: '下一步',
      loadingTitle: '载入中...',
      noCarplate: '请输入车牌号码，例如：AB1234、粤B1Q15N',
      invalidGuid: 'GUID 无效，请重新登录',
      notFound: '没 有 进 场 记 录，请 重 新 输 入',
      charging: ' 付 款 前 请 先 驶 离 充 电 车 位',
      systemError: '查询失败，系统错误，请重新尝试',
      invalidFormat: '车牌格式不正确，请重新检查',
      entryTimestampExpired: '资料已过期，请重新搜索车牌'
    },
    'en': {
      title: 'Parking Payment',
      carParkLabel: '',
      label: 'Please enter your licence plate number',
      placeholder: 'LICENCE PLATE NUMBER',
      back: 'BACK',
      next: 'NEXT',
      loadingTitle: 'Loading...',
      noCarplate: 'Please enter carplate, e.g., AB1234, 粤B1Q15N',
      invalidGuid: 'Invalid GUID, please login again',
      notFound: 'No entry record, please enter again',
      charging: 'Please leave the charging bay before payment ',
      systemError: 'Query failed, system error, please try again',
      invalidFormat: 'Invalid carplate format, please check again',
      entryTimestampExpired: 'Data expired, please search carplate and try again'
    }
  };

  const getTranslation = (key) => translations[currentLang]?.[key] || translations['en'][key];

  // Language selector （你原有，唔使改）
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLangChange = (lang) => {
    setCurrentLang(lang);
    handleClose();
  };

  const getCurrentLangLabel = () => {
    switch (currentLang) {
      case 'zh-tw': return '繁中';
      case 'zh-cn': return '简中';
      case 'en':    return 'Eng';
      default:      return 'Eng';
    }
  };

  const getOtherLanguages = () => {
    if (currentLang === 'zh-tw') return [{ code: 'zh-cn', label: '简中' }, { code: 'en', label: 'Eng' }];
    if (currentLang === 'zh-cn') return [{ code: 'zh-tw', label: '繁中' }, { code: 'en', label: 'Eng' }];
    return [{ code: 'zh-tw', label: '繁中' }, { code: 'zh-cn', label: '简中' }];
  };

  const renderLangSelector = () => (
    <div style={{ 
      position: 'absolute', 
      top: '50px', 
      fontSize: '36px',
      right: '30px', 
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center'
    }}>
<IconButton 
  onClick={handleClick} 
  className="language-switch-button"
  style={{ 
    color: '#4a4a4aff', 
    padding: 0 ,
    position: 'fixed',     // 或者 'fixed' 如果要跟住視窗
  top: '30px',              // 距離頂部
  right: '70px',            // 距離右邊
  }}
>
  <LanguageIcon />
</IconButton>
<span 
  className="language-current-label"
  style={{ 
    marginLeft: '3px', 
    color: '#4a4a4aff', 
    fontSize: '25px' ,
   position: 'fixed', 
  top: '26px',              // 距離頂部
  right: '18px',            // 距離右邊
  }}
>
  {getCurrentLangLabel()}
</span>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} PaperProps={{
        style: { backgroundColor: 'rgba(255, 255, 255, 0.9)', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)' }
      }}>
        {getOtherLanguages().map((lang) => (
          <MenuItem key={lang.code} onClick={() => handleLangChange(lang.code)} style={{ fontSize: '14px', color: '#666' }}>
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );

  // 其餘你原有邏輯（validate、transform、handleSearch 等）完全唔使改，保留晒

  useEffect(() => {
    console.log(`[ENQUIRY LOG] PAGE MOUNTED: carParkInfo =`, carParkInfo, `currentLang = ${currentLang}`);
    if (!carParkInfo?.guid) {
      setError(getTranslation('invalidGuid'));
      navigate('/login', { replace: true });
    }
  }, [carParkInfo?.guid, navigate, currentLang]);

  useEffect(() => {
    if (carplate) {
      setError('');
      if (!validateCarplate(carplate)) {
        setError(getTranslation('invalidFormat'));
      }
    } else {
      setError('');
    }
  }, [carplate, currentLang]);

  const validateCarplate = (value) => {
    const regularPattern = /^[A-Za-z0-9]{1,8}$/;
    const crossBorderPattern = /^[粵粤港澳澳][A-Za-z0-9粵粤港澳澳]{1,8}([粵粤港澳澳])?$/;
    return regularPattern.test(value.toUpperCase()) || crossBorderPattern.test(value);
  };

  const transformCarplate = (plate) => {
    const mapping = { '粤': '', '粵': '', '港': '', '澳': '' };
    return plate.split('').map(char => mapping[char] || char.toUpperCase()).join('');
  };

  const handleKeyPress = (key) => {
    if (carplate.length >= 10) return;
    const newCarplate = (carplate + key).toUpperCase().replace(/[^A-Za-z0-9粵粤港澳澳]/g, '');
    setCarplate(newCarplate);
  };

  const handleBackspace = () => {
    setCarplate(carplate.slice(0, -1));
  };

  const handleInputChange = (e) => {
    let value = e.target.value.toUpperCase().replace(/[^A-Za-z0-9粵粤港澳澳]/g, '');
    if (value.length > 10) value = value.slice(0, 10);
    setCarplate(value);
  };

  const handleSearch = async () => {
    // 你原有全部 handleSearch 邏輯，唔使改，照 copy
    const getCheckValidDate = Date.now();
    console.debug(`[ENQUIRY LOG] CHECK VALIDATION START: ${getCheckValidDate}`);
    if(getCheckValidDate - notDateTime > 3 * 60 * 1000) { // 5分鐘
      setError(getTranslation('entryTimestampExpired'));
      console.debug(`[ENQUIRY LOG] CHECK VALIDATION FAILED: Entry timestamp is too old. Current: ${getCheckValidDate}, Entry: ${notDateTime}`);
      return;
    }
    if (!carplate) { setError(getTranslation('noCarplate')); return; }
    if (!validateCarplate(carplate)) { setError(getTranslation('invalidFormat')); return; }
    if (!carParkInfo?.guid) { setError(getTranslation('invalidGuid')); navigate('/login', { replace: true }); return; }

    const transformedCarplate = transformCarplate(carplate);
    setLoading(true);
    setError('');
    try {
      const apiResponse = await searchCarplate(transformedCarplate, carParkInfo.guid);
      const { resCode, data } = apiResponse;

      if (resCode === 0 || resCode === 2) {
        if (!data?.Carplate || !data?.EntryTime) throw new Error('Invalid data');
        navigate('/details', { state: data });
      } else if (resCode === 1) {
        setError(getTranslation('notFound'));
      } else if (resCode === 101) {
        setError(getTranslation('charging'));
      } else {
        setError(getTranslation('systemError'));
      }
    } catch (err) {
      setError(getTranslation('systemError'));
    } finally {
      setLoading(false);
    }
  };

  if (!carParkInfo?.guid) {
    return (
      <div className="enquiry-page" style={{ position: 'relative', backgroundColor: '#fff' }}>
        {renderLangSelector()}
        <img src="/wilsonparking.jpg" alt="Wilson Parking Logo" className="enquiry-logo" />
        <Container className="enquiry-container" maxWidth="sm" style={{ paddingTop: '60px' }}>
          <Typography className="enquiry-title" variant="h5" style={{ color: '#000' }}>
            {getTranslation('loadingTitle')}
          </Typography>
          <CircularProgress color="inherit" style={{ color: '#ff9800' }} />
        </Container>
      </div>
    );
  }

   // === 主要畫面：加入停車場名稱顯示 + 強制留空位 ===
  return (
    <div className="enquiry-page" style={{ position: 'relative', backgroundColor: '#fff' }}>
      {renderLangSelector()}
      <img src="/wilsonparking.jpg" alt="Wilson Parking Logo" className="enquiry-logo" />
      
      {/* === 固定標題文字（fixed，唔會被推走）=== */}
      <div style={{
        position: 'fixed',
        top: '80px',
        left: '15px',
        right: '15px',           // 加 right 防止太闊溢出
        zIndex: 10,              // 確保喺最上層，唔被其他元素蓋住
        pointerEvents: 'none',   // 重要！令下面嘅 input 可以正常點擊
      }}>
        <Typography 
          variant="h5" 
          className="car-park-title"
          style={{ 
            color: '#000', 
            fontSize: '25px',
            margin: '0 0 0px 0',
            padding: '0',
            lineHeight: '1.2'
          }}
        >
          {getTranslation('carParkLabel')} {getCarParkName()}
        </Typography>

        <Typography 
          className="enquiry-title" 
          variant="h5" 
          style={{ 
            color: '#000', 
            fontSize: '25px',
            margin: '0',
            padding: '0',
            lineHeight: '1.2'
          }}
        >
          {getTranslation('title')}
        </Typography>
      </div>

      {/* === 正常流占位元素：強制留空位，推開下面內容 === */}
      <div style={{
        height: '100px',     // 80px (頂部距離) + 第一行約30px + 間距8px + 第二行約30px + 下面想留20px = 總共約140px
                             // 你可以微調呢個數字，直到視覺上完美（建議 135px - 150px 之間試）
        marginBottom: '5px' // 額外再留多啲底邊距，確保下面箭頭唔貼住
      }} />

      <Container className="enquiry-container" maxWidth="sm" style={{ paddingTop: '5px' }}>

        <img 
          src="/images/payment/arrow.png" 
          alt=">>>"
          style={{ height: '36px', margin: '20px 5px', animation: 'pulse 10s infinite' }}
        />

        <style jsx>{`
          @keyframes pulse {
            0%   { opacity: 0.6; transform: translateX(0); }
            20%  { opacity: 1;   transform: translateX(10px); }
            100% { opacity: 0.6; transform: translateX(0); }
          }
        `}</style>

        <label className="enquiry-label" htmlFor="carplate" style={{ color: '#757575', fontSize: '14px' }}>
          {getTranslation('label')}
        </label>

        {/* 其餘內容完全唔使改（input、keyboard、buttons） */}
        <div className="enquiry-form">
          <div className="enquiry-input-group">
            <TextField
              className="enquiry-input"
              id="carplate"
              value={carplate}
              onChange={handleInputChange}
              placeholder={getTranslation('placeholder')}
              error={!!error}
              helperText={error && !!carplate ? error : ""}
              inputProps={{ 
                maxLength: 10,
                style: { textTransform: 'uppercase', textAlign: 'center', fontSize: '20px' }
              }}  
              sx={{ 
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#fff',
                  borderRadius: '50px',
                  '& fieldset': { borderColor: '#ff9800', borderWidth: '2px' },
                  '&:hover fieldset': { borderColor: '#f57c00' },
                  '&.Mui-focused fieldset': { borderColor: '#ef6c00' },
                },
                '& .MuiInputBase-input::placeholder': {
                  color: '#bdbdbd',
                  opacity: 1,
                  textTransform: 'uppercase',
                },
              }}
            />
          </div>

          <VirtualKeyboard 
            onKeyPress={handleKeyPress}
            onBackspace={handleBackspace}
            lang={currentLang}
          />
        </div>

        <div className="enquiry-buttons">
          <Button
            className="back-button"
            onClick={() => navigate('/')}
            aria-label={getTranslation('back')}
          >
            {getTranslation('back')}
          </Button>

          <Button
            className="next-button"
            onClick={handleSearch}
            disabled={loading || !carplate || !validateCarplate(carplate)}
            aria-label={getTranslation('next')}
          >
            {loading ? <CircularProgress size={28} color="inherit" /> : getTranslation('next')}
          </Button>
        </div>

      </Container>
    </div>
  );
}

export default Enquiry;